import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);

export const errMsg = (e, fallback = "Something went wrong") =>
  e?.response?.data?.detail || e?.message || fallback;
